export default function tidyUri (uri) {
	if (uri.indexOf('www.') > -1 || uri.indexOf('://') > -1)
		return uri;

	return '/' + uri.replace(/^\//g, '');
}
